<template>
  <div class="home">
   <v-container grid-md > 
         <PageIntro v-if="appLogin === false"
              :body="'<p>As of August 26, 2025, all supporters must have a Celtic FC Digital Account to purchase and manage tickets online.</p><p>Sign-in or create a new free Digital Account below.</p>'" />
    </v-container>
    <v-container grid-md > 
        <v-layout style="display: flex; flex-wrap: wrap;">
        <v-flex d-flex class="login-box">
          <main v-if="loggedIn === false">
            <PageIntro
              :heading="'Welcome Back, Sign In to Your Digital Account</span>'"
              :body="'<p>Enter your email and password to access your account.</p>'" />

            <v-container
              fluid
              grid-list-lg
              class="login-container"
              v-if="paramsValid === true"
            >
            <v-alert
            :value="true"
            v-if="error != null"
            type="error"
            v-html="error.message"
          ></v-alert>
          <v-alert :value="true" v-if="success != null" type="success">{{
            success.message
          }}</v-alert>
              <v-layout row wrap>
                <v-flex xs12 sm10 offset-sm1>
                  <v-layout justify-center column>
                    <v-form ref="form" v-model="valid" @submit="login">
                      <v-text-field
                        outline
                        v-model="username"
                        :rules="usernameRules"
                        label="Email *"
                        type="email"
                        required
                      ></v-text-field>

                      <v-text-field
                        outline
                        v-model="pass"
                        :rules="passRules"
                        label="Password *"
                        type="password"
                        required
                      ></v-text-field>

                     <v-layout row align-center mx-1>
                      <router-link to="/forgot-password" class="text-button">Forgotten password?</router-link>
                      <v-spacer />
                      <button type="submit" :disabled="!valid" class="button">Sign in</button>
                    </v-layout>
                    </v-form>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-container>
          </main>
        </v-flex>

          <v-flex d-flex class="home-box">
            <div>
            <!-- <PageIntro 
              :heading="'Don\'t have a digital membership yet?'"
              :body="'<p>Register now and become #PartOfThePride!</p>'+
              '<p>Here\'s some of what you get:</p>'+
              '<ul><li>Watch Pre & post-match news and highlights on {{configStrings.clubStreamingPlatformName}}.</li>'+
              '<li>Listen to live match commentary.</li>'+
              '<li>Exclusive UZ competitions and polls.</li>'+
              '<li>Personalise your digital experience with the Club.</li>'+
              '<li>Access to the Pride Rewards loyalty scheme</li>'+
              '<li>Manage your ticketing account</li></ul></p>'"/> -->
              <PageIntro 
              :heading="'Create a Digital Account'"
              :body="'<p>Register for FREE to buy and manage tickets, shop at the official Celtic FC Store and get exclusive news, updates and competitions.</p>'"/>
              <HomeRegister  />
          </div>
          </v-flex>
        </v-layout>
      </v-container>
      <FooterShout v-if="appLogin === false" :type="'register'"/>
  </div>
</template>


<script>
import PageIntro from "@/components/PageIntro";
import HomeRegister from "@/components/HomeRegister";
  import FooterShout from '@/components/FooterShout'
import axios from "axios";
import qs from "qs";
//import base64url from "base64url";
import crypto from "crypto";

export default {
  components: {
    PageIntro,
    HomeRegister,
    FooterShout
  },
  data() {
    return {
      passRules: [
        (v) => !!v || "Password is required",
        (v) =>
          (v && v.length >= 8) ||
          "Remember, your password will have been at least 8 characters.",
      ],
      usernameRules: [
        (v) => !!v || "Email address is required",
        (v) => /.+@.+/.test(v) || "Email must be valid",
        (v) =>
          !v.includes(" ") || "An email address can not contain any spaces",
      ],
      username: "",
      pass: "",
      hashedPassword: "",
      key: process.env.VUE_APP_GC_AUTH_KEY,
      iv: process.env.VUE_APP_GC_AUTH_IV,
      error: null,
      loggedIn: false, //assume they are logged in
      valid: true,
      paramsValid: true,
      loading: false,
      success: null,
      qsParams: {},
      cookieName: "",
      appLogin: false,
    };
  },
  mounted() {
    this.qsParams = qs.parse(window.location.search.substring(1));
    console.log("qs", this.qsParams);

    if (
      (!this.qsParams["client_id"] ||
        !this.qsParams["response_type"] ||
        !this.qsParams["redirect_uri"] ||
        !this.qsParams["scope"]) &&
      (!localStorage.oauthClientId ||
        !localStorage.oauthResponseType ||
        !localStorage.oauthRedirectUri ||
        !localStorage.oauthScope)
    ) {
      this.paramsValid = false;
    } else {
      if (this.qsParams["client_id"]) {
        // if we detect it is coming from a URL request, write into local storage with the parameter values
        localStorage.oauthClientId = this.qsParams["client_id"];
        localStorage.oauthResponseType = this.qsParams["response_type"];
        localStorage.oauthRedirectUri = this.qsParams["redirect_uri"];
        localStorage.oauthScope = this.qsParams["scope"];
        localStorage.oauthState = this.qsParams["state"];
        localStorage.oauthNonce = this.qsParams["nonce"];
      }
      localStorage.loginFlow = "oauth2";
    }


    console.log("valid?", this.paramsValid);

    if (this.paramsValid === false) {
      this.error = { message: "Invalid parameters passed by partner platform" };
    } else {
      console.log("All parameters passed");
    }
  },
  methods: {
    async login(e) {
      e.preventDefault();
      let cipher = crypto.createCipheriv('aes-256-cbc', this.key, this.iv);
      let encrypted = cipher.update(this.pass, 'utf8', 'base64');
      encrypted += cipher.final('base64');
      this.hashedPassword = encrypted
      
      var data = JSON.stringify({
        client_id: localStorage.oauthClientId,
        client_secret: localStorage.oauthClientSecret,
        response_type: localStorage.oauthResponseType,
        redirect_uri: localStorage.oauthRedirectUri,
        state: localStorage.oauthState,
        nonce: localStorage.oauthNonce,
        scope: localStorage.oauthScope,
        username: this.username,
        ciptoken: this.hashedPassword,
      });

      var config = {
        method: "post",
        url: process.env.VUE_APP_GC_AUTH_ENDPOINT,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
      this.loading = true;

      //console.log(config)

      var vm = this;
      axios(config)
        .then(function (response) {
          console.log("making request for code");
          //console.log(JSON.stringify(response.data));
          //console.log("AUTH CODE", response.data.code);
          if (typeof response.data.code == "undefined") {
            vm.loading = false;
            vm.error = {
              message: "Unable to login, please check your email and password.",
            };
          } else {
            vm.loading = false;

            var oauthRedirectUri = localStorage.oauthRedirectUri;
            var oauthState = localStorage.oauthState;

            localStorage.removeItem("oauthClientId");
            localStorage.removeItem("oauthClientSecret");
            localStorage.removeItem("oauthResponseType");
            localStorage.removeItem("oauthRedirectUri");
            localStorage.removeItem("oauthScope");
            localStorage.removeItem("oauthState");
            localStorage.removeItem("oauthNonce");
            localStorage.removeItem("loginFlow");
            window.location.replace(
              oauthRedirectUri +
                "?code=" +
                response.data.code +
                "&state=" +
                oauthState
            );
          }
        })
        .catch(function (error) {
          console.log(error);
          vm.loading = false;
          vm.error = {
            message: "There was an error whilst retrieving authorisation",
          };
        });
    },
    signUpSelected() {
      alert("signing up");
    },
    getCookieValue(cookieName) {
      const cookies = document.cookie.split(";");
      for (const cookie of cookies) {
        const [name, value] = cookie.trim().split("=");
        if (name === cookieName) {
          return decodeURIComponent(value);
        }
      }
      return null; // Return null if the cookie with the specified name is not found
    },
  },
};
</script>
<style scoped>

.login-box {
  width: 100%;
  margin-bottom:40px;
  @media screen and (min-width: 700px){
    width: 50%;
    margin-bottom:10px;
  }
}

.home-box {
  width: 100%;
  @media screen and (min-width: 700px){
    width: 50%;
  }
}
.notification {
  text-align: center;
}
</style>